import ApartmentIndex from './Index'
import ApartmentForm from './Form'

export default [
  {
    path: '/apartment',
    name: 'apartment',
    component: ApartmentIndex,
    meta: {
      auth: true,
      bodyClass: 'navbar-top',
      breadcrumb: 'Apartments'
    }
  },
  {
    path: '/apartment/details/:oid',
    name: 'apartment.details',
    props: true,
    component: ApartmentForm,
    meta: {
      breadcrumb: 'Apartment Details'
    }
  }
]
